import { useFeatureFlagOverrides } from '@/common/providers/featureFlagOverrideContext';

interface FeatureFlagOverrideBadgeProps {
  onClick: () => void;
}

export const FeatureFlagOverrideBadge: React.FC<FeatureFlagOverrideBadgeProps> = ({ onClick }) => {
  const { overrides, hasOverrides, isDialogOpen } = useFeatureFlagOverrides();

  if (!hasOverrides() || isDialogOpen) {
    return null;
  }

  const overrideCount = Object.keys(overrides).length;

  return (
    <button
      onClick={onClick}
      className="fixed bottom-16 right-6 z-50 px-3 py-2 bg-bg-warning text-text-neutral-primary rounded-lg shadow-lg hover:bg-bg-warning-hovered transition-colors cursor-pointer border-2 border-border-neutral-bold focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-border-neutral-focus"
      title="Click to open feature flag dev tools"
      type="button"
    >
      <div className="flex items-center gap-2">
        <span className="font-bold text-xs font-mono">DEV</span>
        <div className="w-px h-4 bg-border-neutral-bold" />
        <span className="font-mono text-sm font-bold">{overrideCount}</span>
        <span className="text-xs font-mono">flag{overrideCount !== 1 ? 's' : ''}</span>
      </div>
    </button>
  );
};
